/* @flow */

import * as React from 'react';

import BasePromptCard from 'src/shared/ui/component/data-display/BasePromptCard';

type Props = {
  icon?: React.Node,
  children?: React.Node,
  confirmCta: string,
  text: string,
  description?: string,
  onClick: () => void,
  handleDismiss: () => void,
};

const MarketPromptCardDumb = ({
  icon,
  children,
  confirmCta,
  text,
  description,
  onClick,
  handleDismiss,
}: Props): React.Node => (
  <BasePromptCard
    icon={icon}
    text={text}
    description={description}
    confirmCta={confirmCta}
    onClick={onClick}
    handleDismiss={handleDismiss}
  >
    {children && children}
  </BasePromptCard>
);

export default React.memo<Props>(MarketPromptCardDumb);
